import { render, staticRenderFns } from "./LetterStepMandate.vue?vue&type=template&id=05bf57ba&scoped=true&"
import script from "./LetterStepMandate.vue?vue&type=script&lang=ts&"
export * from "./LetterStepMandate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bf57ba",
  null
  
)

export default component.exports